import {media} from '@sail/engine';
import {css, tokens} from '@sail/ui';
import {helmTokens} from '@sail/helm';

// TODO: These styles will be replaced when React components are set up with Markdoc
export const styles = {
  markdownStyles: css.global({
    '.ArticleMarkdown > Article': {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      fontFamily: `${tokens.font.heading.family.typeface}`,
    },
    '.ArticleMarkdown :where(h1, h2, h3, h4, h5, h6, p)': {
      padding: `0 ${tokens.space.medium}`,
      color: `${tokens.color.text.emphasized}`,
      margin: '0',
    },
    '.ArticleMarkdown h1': {
      fontSize: `${tokens.font.heading.xlarge.size}`,
      lineHeight: `${tokens.font.heading.xlarge.lineHeight}`,
      fontWeight: `${tokens.font.heading.xlarge.weight}`,
      letterSpacing: `${helmTokens.letterSpacing.xsmall}`,
    },
    '.ArticleMarkdown h2': {
      fontSize: `${tokens.font.heading.large.size}`,
      lineHeight: `${tokens.font.heading.large.lineHeight}`,
      fontWeight: `${tokens.font.heading.large.weight}`,
      letterSpacing: `${helmTokens.letterSpacing.small}`,
    },
    '.ArticleMarkdown h3': {
      fontSize: `${tokens.font.heading.medium.size}`,
      lineHeight: `${tokens.font.heading.medium.lineHeight}`,
      fontWeight: `${tokens.font.heading.medium.weight}`,
      letterSpacing: `${helmTokens.letterSpacing.medium}`,
    },
    '.ArticleMarkdown :where(h4, h5, h6)': {
      fontSize: `${tokens.font.heading.small.size}`,
      lineHeight: `${tokens.font.heading.small.lineHeight}`,
      fontWeight: `${tokens.font.heading.small.weight}`,
    },
    '.ArticleMarkdown p': {
      fontSize: `${tokens.font.body.medium.size}`,
      lineHeight: `${tokens.font.body.medium.lineHeight}`,
      fontWeight: `${tokens.font.body.medium.weight}`,
      color: `${tokens.color.neutral[700]}`,
      letterSpacing: `${helmTokens.letterSpacing.large}`,
    },
    [media.up(tokens.viewport.large)]: {
      '.ArticleMarkdown p': {
        fontSize: `${tokens.font.body.large.size}`,
        lineHeight: `${tokens.font.body.large.lineHeight}`,
        fontWeight: `${tokens.font.body.large.weight}`,
        maxWidth: 'calc(calc(1080px * 0.25) * 3)',
        letterSpacing: `${helmTokens.letterSpacing.large}`,
      },
    },
    '.ArticleMarkdown :where(ol, ul)': {margin: '0'},
    '.ArticleMarkdown ul': {
      listStyle: 'none',
    },
    '.ArticleMarkdown li': {
      position: 'relative',
      paddingRight: 'xlarge',
      fontSize: 'large',
    },
    '.ArticleMarkdown li::before': {
      position: 'absolute',
      content: '" "',
      top: '9px',
      left: '-21px',
      width: '7px',
      height: '7px',
      borderRadius: '50%',
      backgroundColor: '#cfd7df',
    },
    '.ArticleMarkdown :where(li + li, li ul li:first-child)': {
      marginTop: '16px',
    },
    '.ArticleMarkdown a': {
      fontSize: `${tokens.font.body.medium.emphasized.size}`,
      lineHeight: `${tokens.font.body.medium.emphasized.lineHeight}`,
      fontWeight: `${tokens.font.body.medium.emphasized.weight}`,
      color: `${tokens.color.text.action.primary}`,
      textDecoration: 'none',
      transition: `all ${helmTokens.transition.hover}`,
      letterSpacing: `${helmTokens.letterSpacing.large}`,
    },
    '.ArticleMarkdown a:hover': {
      color: `${tokens.color.text.action.primary.hovered}`,
    },
  }),
  markdownMediaStyles: css.global({
    [media.up(tokens.viewport.medium)]: {
      '.ArticleMarkdown.ArticleMarkdown--mediaQuery p': {
        font: 'body.large',
        maxWidth: 'calc(calc(1080px * 0.25) * 3)',
      },
      '.ArticleMarkdown.ArticleMarkdown--mediaQuery a': {
        font: 'body.large.emphasized',
      },
      '.ArticleMarkdown.ArticleMarkdown--mediaQuery li::before': {
        top: '11px',
        left: '-23px',
        width: '8px',
        height: '8px',
      },
    },
  }),
};
